import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { GrayButton, SecondaryButton, Spinner, EmptyState } from 'components';
import styles from './styles.scss';

var FacebookAdAccountConnectionModal = /*#__PURE__*/function (_React$Component) {
  _inherits(FacebookAdAccountConnectionModal, _React$Component);

  var _super = _createSuper(FacebookAdAccountConnectionModal);

  function FacebookAdAccountConnectionModal() {
    _classCallCheck(this, FacebookAdAccountConnectionModal);

    return _super.apply(this, arguments);
  }

  _createClass(FacebookAdAccountConnectionModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          account = _this$props.account,
          openFacebook = _this$props.openFacebook,
          phase = _this$props.phase;

      switch (phase) {
        case 0:
          return /*#__PURE__*/React.createElement("div", {
            className: styles.modalBodyContent
          }, /*#__PURE__*/React.createElement(EmptyState, {
            buttonLabel: "Approve Request",
            buttonOnClick: function buttonOnClick() {
              return openFacebook(account);
            },
            text: "Grant us Permission",
            subtext: "To run ads on Facebook, we need to have permission to administer your Facebook page. We have sent you an admin request via Facebook, you must approve this request before continuing.",
            iconName: "fa fa-handshake-o",
            iconSize: "95px",
            style: {
              marginTop: 24
            }
          }));

        case 1:
          return /*#__PURE__*/React.createElement("div", {
            className: styles.modalBodyContent
          }, /*#__PURE__*/React.createElement(EmptyState, {
            text: "Nearly There",
            subtext: 'Click the "Finish" button below to complete the setup.',
            iconName: "fa fa-link",
            iconSize: "95px",
            style: {
              marginTop: 24
            }
          }));

        case 2:
          return /*#__PURE__*/React.createElement("div", {
            className: styles.modalBodyContent
          }, /*#__PURE__*/React.createElement(EmptyState, {
            text: "Connecting Ad Account",
            subtext: 'This may take a moment...',
            iconSize: "95px",
            iconName: "fa fa-spinner fa-spin",
            style: {
              marginTop: 24
            }
          }));

        default:
          return null;
      }
    }
  }]);

  return FacebookAdAccountConnectionModal;
}(React.Component);

export { FacebookAdAccountConnectionModal as default };